import { Link, useLocation } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import { Fragment } from 'react';

import { useIsExtensionSurface } from '@apps/web/components/phoebe_chat/extension_surface_context';
import { PAPER_OUTLINE_BUTTON_XS_CLASS } from '@apps/web/features/phoebe_chat_v3/ui/data_presentation_cards/shared';

// Matching the path segment rather than the whole pathname keeps an
// unrelated route that happens to carry the same uuid from swallowing the
// chip.
export function isOutreachDetailPathname(
    pathname: string,
    outreachId: string,
): boolean {
    const segments = pathname.toLowerCase().split('/');
    const outreachesIndex = segments.indexOf('outreaches');
    return (
        outreachesIndex !== -1 &&
        segments[outreachesIndex + 1] === outreachId.toLowerCase()
    );
}

export function V3OutreachLinkChip({
    outreachId,
}: {
    readonly outreachId: string;
}) {
    const { pathname } = useLocation();
    const isExtensionSurface = useIsExtensionSurface();
    if (isOutreachDetailPathname(pathname, outreachId)) {
        return null;
    }
    const label = (
        <Fragment>
            {isExtensionSurface ? 'Open in web' : 'Go to outreach'}
            <ArrowRight className="ml-1 size-3" />
        </Fragment>
    );
    // The extension's link guard leaves an absolute URL alone, so this stays
    // the one deliberate escape hatch out to the full app.
    if (isExtensionSurface) {
        return (
            <a
                href={new URL(
                    `/outreaches/${outreachId}`,
                    window.location.origin,
                ).toString()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`v3-outreach-link-${outreachId}`}
                className={PAPER_OUTLINE_BUTTON_XS_CLASS}
            >
                {label}
            </a>
        );
    }
    return (
        <Link
            to="/outreaches/$callout-id"
            params={{ 'callout-id': outreachId }}
            data-testid={`v3-outreach-link-${outreachId}`}
            className={PAPER_OUTLINE_BUTTON_XS_CLASS}
        >
            {label}
        </Link>
    );
}
